import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { useImpersonation } from '@/contexts/ImpersonationContext';
import { loadMySupportTickets, unreadReplies } from '@/lib/supportTickets';

/**
 * The effective user's own support tickets, and the ones where support wrote
 * after they last looked. Refreshed every two minutes and on window focus, so a
 * reply shows up on Contact Support without a reload.
 */
export function useMySupportTickets() {
  const { user } = useAuth();
  const { isImpersonating, impersonatedUserId } = useImpersonation();
  // CLAUDE.md rule #9: the cache key carries the effective user.
  const effectiveUserId = (isImpersonating && impersonatedUserId) || user?.id || null;

  const query = useQuery({
    queryKey: ['my-support-tickets', effectiveUserId],
    queryFn: () => loadMySupportTickets(effectiveUserId as string),
    enabled: !!effectiveUserId,
    staleTime: 60_000,
    refetchInterval: 120_000,
  });

  const tickets = query.data ?? [];
  return { tickets, unread: unreadReplies(tickets), effectiveUserId, isImpersonating, refetch: query.refetch };
}
